import { render, staticRenderFns } from "./ComplaintTypeFilter.vue?vue&type=template&id=b23a0f8a&"
import script from "./ComplaintTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports